"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var Info_1 = require("../../gen-src/icons/Info");
var Localize_1 = require("../../gen-src/Localize");
var MessageUtils_1 = require("../displayUtils/MessageUtils");
var AboutHeaderDetailsStyles_1 = require("../style/AboutHeaderDetailsStyles");
var LayoutComponents_1 = require("../style/LayoutComponents");
function renderFileType(connectionType) {
    var helpText = getHelpTextForFile(connectionType);
    var friendlyConnectionTypeName = MessageUtils_1.messageForConnectionType(connectionType);
    return renderAboutFileTextDetailItem(Localize_1.Messages.FileType(), friendlyConnectionTypeName, helpText);
}
exports.renderFileType = renderFileType;
// This is based off of the ConnectToAllowedClasses, will need to manually add new types from that which need this messaging
function getHelpTextForFile(connectionType) {
    switch (connectionType) {
        case 'csv':
        case 'cloudfile:box-semistructpassivestore-direct':
        case 'cloudfile:box-textscan':
        case 'cloudfile:dropbox-semistructpassivestore-direct':
        case 'cloudfile:dropbox-textscan':
        case 'cloudfile:googledrive-semistructpassivestore-direct':
        case 'cloudfile:googledrive-textscan':
        case 'cloudfile:onedrive-semistructpassivestore-direct':
        case 'cloudfile:onedrive-textscan':
        case 'dataengine':
        case 'textclean':
        case 'textscan':
        case 'textscan-reader':
            return Localize_1.Messages.FileSingleTable();
        case 'cloudfile:box-excel-direct':
        case 'cloudfile:dropbox-excel-direct':
        case 'cloudfile:googledrive-excel-direct':
        case 'cloudfile:onedrive-excel-direct':
        case 'excel':
        case 'excel-direct':
        case 'excel-reader':
        case 'google-sheets':
        case 'hyper':
        case 'msaccess':
            return Localize_1.Messages.FileMultipleTables();
        default:
            return '';
    }
}
function renderAboutHeaderTextDetailItem(label, value, testId) {
    return (React.createElement("div", { className: AboutHeaderDetailsStyles_1.aboutHeaderDetailItem, key: testId },
        React.createElement(LayoutComponents_1.VerticalFlexContainer, { fillFlexParent: true },
            React.createElement("div", { className: AboutHeaderDetailsStyles_1.aboutHeaderDetailLabel }, label),
            React.createElement("span", { "data-tb-test-id": testId, title: value, className: AboutHeaderDetailsStyles_1.aboutHeaderDetailsTextElide }, value))));
}
exports.renderAboutHeaderTextDetailItem = renderAboutHeaderTextDetailItem;
function renderAboutFileTextDetailItem(label, value, helpText) {
    return (React.createElement("div", { className: AboutHeaderDetailsStyles_1.aboutHeaderDetailItem, key: 'table-details-connection-type-test-id' },
        React.createElement(LayoutComponents_1.VerticalFlexContainer, { fillFlexParent: true },
            React.createElement("div", { className: AboutHeaderDetailsStyles_1.aboutHeaderDetailLabel }, label),
            React.createElement("span", { "data-tb-test-id": 'table-details-connection-type-test-id', title: value },
                value,
                React.createElement("span", { title: helpText },
                    React.createElement(Info_1.SvgInfo, { className: AboutHeaderDetailsStyles_1.aboutHeaderInfoIcon }))))));
}
function renderAboutHeaderDescriptionDetailItem(description, testId) {
    return (React.createElement("div", { className: AboutHeaderDetailsStyles_1.aboutHeaderDescription },
        React.createElement("div", { className: AboutHeaderDetailsStyles_1.aboutHeaderDetailLabel }, Localize_1.Messages.Description()),
        React.createElement("div", { className: AboutHeaderDetailsStyles_1.aboutHeaderDescriptionContent, "data-tb-test-id": testId }, description ? description :
            React.createElement("div", { className: AboutHeaderDetailsStyles_1.aboutHeaderPlaceholderText }, Localize_1.Messages.NoDescriptionAvailable()))));
}
exports.renderAboutHeaderDescriptionDetailItem = renderAboutHeaderDescriptionDetailItem;
function renderAboutHeaderDatabaseNameLinkItem(label, databaseName, databaseId, testId, urls) {
    return (React.createElement("div", { className: AboutHeaderDetailsStyles_1.aboutHeaderDetailItem, key: testId },
        React.createElement(LayoutComponents_1.VerticalFlexContainer, { fillFlexParent: true },
            React.createElement("div", { className: AboutHeaderDetailsStyles_1.aboutHeaderDetailLabel }, label),
            React.createElement(react_router_dom_1.Link, { to: urls.catalogDatabasePath(databaseId), title: databaseName, className: AboutHeaderDetailsStyles_1.aboutHeaderDetailsTextElide, "data-tb-test-id": testId }, databaseName))));
}
exports.renderAboutHeaderDatabaseNameLinkItem = renderAboutHeaderDatabaseNameLinkItem;
//# sourceMappingURL=AboutHeaderDetailItems.js.map